import { Fragment } from "react";

import { ConditionalWrapper } from "../ConditionalWrapper";
import { Row } from "../Layout";
import getColumns from "./getColumns";
import getField from "./getField";

const getRows = (rows, uid) =>
    rows?.map((row) => (
        <Fragment key={uid(row)}>
            <ConditionalWrapper
                condition={row?.type !== "hidden"}
                Wrapper={Row}
                variant={row?.layout || "form.row.columns"}
            >
                {row?.columns ? getColumns(row?.columns, uid) : getField(row)}
            </ConditionalWrapper>
        </Fragment>
    ));

export default getRows;
